export class KitBenefit {
	uniqueID: string;
	enrollmentName: string;
	isChangeAvailable: boolean;
	isTermAvailable: boolean;
	isSelected: boolean;
	isRequired: boolean;
	isAddSelected: boolean;
	isChangeSelected: boolean;
	isTermSelected: boolean;
	availableOn: string;
	unavailableOn: string;
	currentCoverage: string;

	constructor() {
		this.uniqueID = null;
		this.enrollmentName = null;
		this.isChangeAvailable = false;
		this.isTermAvailable = false;
		this.isSelected = false;
		this.isRequired = false;
		this.isAddSelected = false;
		this.isChangeSelected = false;
		this.isTermSelected = false;
		this.availableOn = null;
		this.unavailableOn = null;
		this.currentCoverage = null;
	}
}

export class KitBenefitCollection {
	totalItems: number;
	totalPages: number;
	pageSize: number;
	isMultiSelect?: boolean;
	items: KitBenefit []

	constructor() {
		this.totalItems = 0;
		this.totalPages = 0;
		this.pageSize = 0;
		this.isMultiSelect = false;
		this.items = new Array<KitBenefit>();
	}
}

export class KitBenefitBuyUpTableData {
	uniqueID: string;
	enrollmentName: string;
	isAddAvailable: boolean;
	isChangeAvailable: boolean;
	isTermAvailable: boolean;
	isRequired: boolean;
	isAddSelected: boolean;
	isChangeSelected: boolean;
	isTermSelected: boolean;
	currentCoverage: string;

	constructor() {
		this.uniqueID = null;
		this.enrollmentName = null;
		this.isAddAvailable = false;
		this.isChangeAvailable = false;
		this.isTermAvailable = false;
		this.isAddSelected = false;
		this.isChangeSelected = false;
		this.isTermSelected = false;
		this.currentCoverage = null;
	}
}

export class KitBenefitPayload {
	uniqueIDs: string[];

	constructor() {
		this.uniqueIDs = [];
	}
}

export class KitBenefitBuyUpPayload {
	selectedBuyupKitBenefits: BuyupKitBenefitSelection[];

	constructor() {
		this.selectedBuyupKitBenefits = new Array<BuyupKitBenefitSelection>();
	}
}

export class BuyupKitBenefitSelection {
	uniqueId: string;
	isChangeSelected: boolean;
	isTermSelected: boolean;
	isAddSelected: boolean;

	constructor() {
		this.uniqueId = null;
		this.isChangeSelected = false;
		this.isTermSelected = false;
		this.isAddSelected = false;
	}
}